import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: BASE ? `${BASE}/api` : "/api", withCredentials: true });

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => {
        const field = Array.isArray(e?.loc) ? e.loc[e.loc.length - 1] : "";
        return e?.msg ? `${field ? field.replace(/_/g, " ") + ": " : ""}${e.msg}` : "";
      })
      .filter(Boolean)
      .join(" · ");
  }
  return detail?.msg || String(detail);
}

export function track(event, props = {}) {
  try {
    window.posthog?.capture?.(event, props);
  } catch (e) {
    /* analytics must never break the UI */
  }
}
